import { Box, Flex } from "@chakra-ui/layout";
import { Text } from "@chakra-ui/react";
import { TipoDestinoEnum } from "core/features/documentos/enums";
import { TipoEntidadeEnum } from "core/resources/enums/conta";
import { Control, UseFormSetValue } from "react-hook-form";
import Field from "../Input/Field";
import SelectTipoDestino from "../Input/SelectTipoDestino";
import RenderSelectEntidade from "./RenderSelectEntidade";

interface SelectDestinoProps {
  tenantId: string;
  control: Control<{ tipoDestinoId: string; destinoId?: string } & any, object>;
  form: { tipoDestinoId: string; destinoId?: string } & any;
  setValue: UseFormSetValue<
    { tipoDestinoId: string; destinoId?: string } & any
  >;
  selectSize?: "large" | "small";
  inputSize?: "sm" | "md" | "lg" | "xs";
  showEmail?: boolean;
  showPessoa?: boolean;
  showCargo?: boolean;
  label?: string;
  required?: boolean;
  tiposPessoa?: TipoEntidadeEnum[];
  mr?: string;
}

function SelectDestino({
  tenantId,
  control,
  form,
  setValue,
  selectSize = "large",
  inputSize = "md",
  showEmail = false,
  showPessoa = false,
  showCargo = false,
  label = "Para: ",
  required = true,
  tiposPessoa,
  mr = "3",
}: SelectDestinoProps) {
  return (
    <>
      <Flex alignItems="center" w="100%">
        <Box mr={mr}>
          <Text fontSize={14}>{label}</Text>
        </Box>
        <Flex mr={3} w="34%">
          <Field
            rules={{
              required,
            }}
            name="tipoDestinoId"
            control={control}
            render={({ field, isInvalid }) => (
              <SelectTipoDestino
                onChange={(v) => {
                  field.onChange(v);
                  setValue("destinoId", undefined);
                }}
                value={field.value}
                isInvalid={isInvalid}
                size={selectSize}
                showEmail={showEmail}
                showPessoa={showPessoa}
                showCargo={showCargo}
              />
            )}
          />
        </Flex>
        {form.tipoDestinoId !== TipoDestinoEnum.TodasUnidades ? (
          <Flex flex={1}>
            <Field
              rules={{
                required,
              }}
              shouldUnregister
              control={control}
              name="destinoId"
              render={({ field, isInvalid }) => (
                <RenderSelectEntidade
                  tenantId={tenantId}
                  field={field}
                  isInvalid={isInvalid}
                  onChangeCargo={field.onChange}
                  onChangeUnidade={field.onChange}
                  onChangeGrupo={field.onChange}
                  onChangePessoa={field.onChange}
                  tipoDestinoId={form.tipoDestinoId}
                  selectSize={selectSize}
                  inputSize={inputSize}
                  showValue
                  tiposPessoa={tiposPessoa}
                />
              )}
            />
          </Flex>
        ) : null}
      </Flex>
    </>
  );
}

export default SelectDestino;
